import { api, setAuthTokens, clearAuthTokens } from './client';
import type { AuthResponse, User } from '@/types/domain';

export async function loginWithTgInitData(initData: string): Promise<AuthResponse> {
  const data = await api.post<AuthResponse>('/auth/tg-mini-app/', {
    body: { init_data: initData },
    anonymous: true,
  });
  setAuthTokens(data.access, data.refresh);
  return data;
}

export function logout(): void {
  clearAuthTokens();
}

export async function fetchMe(): Promise<User> {
  return api.get<User>('/auth/me/');
}

export async function becomeSpecialist(): Promise<User> {
  return api.post<User>('/auth/become-specialist/');
}
